import { Form, Input } from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  meagures: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal = ({
  form,
  meagures,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل مقياس" : "إضافة مقياس"}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        initialValues={initialValues}
        className="grid grid-cols-1 gap-3"
      >
        {/* In edit mode, display the MeagureID as disabled */}
        {isEditing && (
          <Form.Item
            name="MeagureID"
            label="كود المقياس"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
        )}

        {/* Meagure Name */}
        <Form.Item
          name="MeagureName"
          label="اسم المقياس"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
